// extracted by mini-css-extract-plugin
export default {"loader":"ProjectRoleRow_loader__5ZAPK"};